const renderCaseModal = () => {
  const pageBody = document.querySelector('body');
  const caseModal = document.querySelector('[data-modal="case-modal"]');
  if (!caseModal) return;

  const modalTitle = caseModal.querySelector('b');
  const modalImage = caseModal.querySelector('img');
  const modalChange = caseModal.querySelector('span');
  const modalText = caseModal.querySelector('.cases__modal-text');

  const onCardClick = (evt) => {
    if (evt.target.closest('[data-open-modal="case-modal"]')) {
      const targetCard = evt.target.closest('.cases__slide');
      const cardName = targetCard.querySelector('b').textContent;
      const cardImage = targetCard.dataset.image;
      const cardChange = targetCard.querySelector('.change').outerHTML;
      const cardText = Array.from(targetCard.querySelectorAll('.cases__slide-text p')).map((paragraph) => paragraph.outerHTML); 
      
      modalTitle.textContent = cardName;
      modalImage.src = cardImage;
      modalImage.alt = cardName;
      modalChange.innerHTML = cardChange;
      modalText.innerHTML = cardText.join(' ');
    }
  };

  pageBody.addEventListener('click', onCardClick);
};

export default renderCaseModal;
